import styled from "styled-components";
export const IconWrapper = styled.div `
  ${({ theme, stylingType }) => `${stylingType === "withAdditionalElement"
    ? `color: ${theme.colors.grey15};`
    : "color: inherit;"}`}

  ${({ alignment }) => `${alignment === "vertical"
    ? "width: 2.5rem; min-width: 2.5rem; display: flex; justify-content: center;"
    : "width: auto; min-width: auto;"}`}
  @media ${({ theme }) => theme.device.touch} {
    ${({ alignment }) => `${alignment === "vertical"
    ? "width: 2.75rem; min-width: 2.75rem;"
    : "width: auto; min-width: auto;"}`}
  }
  ${({ alignment, withIcon }) => `padding-right: ${alignment === "horizontal" && withIcon ? "0.5rem" : "0"};`}
  ${({ alignment, stylingType }) => `margin-left: ${alignment === "vertical" && stylingType !== "withIcon" ? "auto" : "0"};`}
`;
